<mat-form-field style="width: 100%">
    <mat-label>{{ placeholder }}</mat-label>
    <input matInput [matAutocomplete]="autoMaterial" [formControl]="materialFormCtrl" [placeholder]="placeholder" />
    <mat-autocomplete
        #autoMaterial="matAutocomplete"
        [displayWith]="materialMapper"
        (optionSelected)="autocompleteMaterialSelected($event)"
    >
        <mat-option *ngFor="let m of materialien | async" [value]="m">
            <span>{{ m.artikel_me }}</span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
